module.exports = require('./lib/geocoder');
